export const DRAGGED_ITEM_TOP = '--responsive-grid-dragged-item-top';
export const DRAGGED_ITEM_LEFT = '--responsive-grid-dragged-item-left';
export const DRAGGED_ITEM_WIDTH = '--responsive-grid-dragged-item-width';
export const DRAGGED_ITEM_HEIGHT = '--responsive-grid-dragged-item-height';
